import { createSelector } from 'reselect';

const selectAssociatedVendorCampaign = (state: any) => state.associatedVendorCampaign;


export const selectAssociatedVendorCampaignCurrentItem = createSelector([selectAssociatedVendorCampaign], (associatedVendorCampaign) => associatedVendorCampaign.current);

export const selectAssociatedVendorCampaignListItems = createSelector([selectAssociatedVendorCampaign], (associatedVendorCampaign) => associatedVendorCampaign.list);

export const selectAssociatedVendorCampaignItemById = (itemId: any) =>
    createSelector(selectAssociatedVendorCampaignListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectAssociatedVendorCampaignQueryItems = createSelector([selectAssociatedVendorCampaign], (associatedVendorCampaign) => associatedVendorCampaign.query);

export const selectAssociatedVendorCampaignCreatedItem = createSelector([selectAssociatedVendorCampaign], (associatedVendorCampaign) => associatedVendorCampaign.create);

export const selectAssociatedVendorCampaignUpdatedItem = createSelector([selectAssociatedVendorCampaign], (associatedVendorCampaign) => associatedVendorCampaign.update);

export const selectReadItem = createSelector([selectAssociatedVendorCampaign], (associatedVendorCampaign) => associatedVendorCampaign.read);

export const selectAssociatedVendorCampaignDeletedItem = createSelector([selectAssociatedVendorCampaign], (associatedVendorCampaign) => associatedVendorCampaign.delete);

export const selectAssociatedVendorCampaignearchedItems = createSelector([selectAssociatedVendorCampaign], (associatedVendorCampaign) => associatedVendorCampaign.search);

export const selectAssociatedVendorCampaignItemsCount = createSelector([selectAssociatedVendorCampaign], (associatedVendorCampaign) => associatedVendorCampaign.count);

export const selectAssociatedVendorCampaignItemsFilter = createSelector([selectAssociatedVendorCampaign], (associatedVendorCampaign) => associatedVendorCampaign.filter);